import Home from "pages/Home/HomePage";

export const iphone18route = [
  {
    path: "/dien-thoai-iphone-18-pro-256gb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-18-pro-512gb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-18-pro-1tb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-18-pro-2tb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-18-pro-max-256gb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-18-pro-max-256gb-2",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-18-pro-max-512gb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-18-pro-max-512gb-2",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-18-pro-max-1tb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-18-pro-max-2tb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-duo-256gb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-duo-512gb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-duo-1tb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-duo-2tb",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
];
